import React from 'react';
import PlanningFactorModal from 'spw-components/dialogs/total-program/planning-factor-modal';
import CirculationMultiplierModal from 'spw-components/dialogs/total-program/circulation-multiplier-modal';
import { cond } from 'lodash';
import { always, equals, T } from 'ramda';
import TotalAvailableUsfModal from 'spw-components/dialogs/total-program/total-available-usf-modal';
import { SummaryCalculator } from '../../../models/ProgramSummaryCalculator';
import { PlainProgramScenario } from '../../../models/Scenario';

interface TotalProgramFactorModalProps {
  editFactor: string;
  scenarios: PlainProgramScenario[];
  showDialog: boolean;
  setShowDialog: (showDialog: boolean) => void;
  setEditFactor: (editFactor: string) => void;
  totalProgram: PlainProgramScenario;
  summaryCalculator: SummaryCalculator;
}

const TotalProgramFactorModal: React.FC<TotalProgramFactorModalProps> = ({
  editFactor,
  scenarios,
  summaryCalculator,
  ...props
}: TotalProgramFactorModalProps) =>
  cond([
    [
      equals('multiplier'),
      () => (
        <CirculationMultiplierModal
          {...props}
          summaryCalculator={summaryCalculator}
        />
      ),
    ],
    [
      equals('planning-factor'),
      () => (
        <PlanningFactorModal {...props} summaryCalculator={summaryCalculator} />
      ),
    ],
    [
      equals('total-available-usf'),
      () => <TotalAvailableUsfModal {...props} scenarios={scenarios} />,
    ],
    [T, always(<></>)],
  ])(editFactor);

export default TotalProgramFactorModal;
